module.exports = __webpack_public_path__ + "img/index-section6-friend3_a.f619f218.svg";